export default __webpack_public_path__ + "static/media/Image-3.3d7cf3fb.png";